import Vue from "vue";
import vailcode from "@utils/errcode";
import lang from "@i18n/i18nOption.json";
const { langDefault, langList } = lang;

export default {
  namespaced: true,
  state: {
    isMobile: true,
    tonConnect: false,
    tonAddress: null,
    htmlSize: {
      w: 0,
      h: 0,
    },
    deviceType: null,
  },
  mutations: {
    setDeviceType: (state, payload) => {
      state.deviceType = payload;
    },
    setIsMobile: (state, payload) => {
      state.isMobile = payload;
    },
    setHtmlSize: (state, payload) => {
      for (const key in payload) {
        Vue.prototype.$set(state.htmlSize, key, payload[key]);
      }
    },
    setTonConnect: (state, payload) => {
      state.tonConnect = payload;
    },
    setTonAddress: (state, payload) => {
      state.tonAddress = payload;
    },
  },
  actions: {
    getDeviceType: ({ commit }) => {
      let deviceType = "";
      const ua = navigator.userAgent;
      
      const logicalWidth = Math.min(screen.width, screen.height);
      const logicalHeight = Math.max(screen.width, screen.height);
      const dpr = window.devicePixelRatio || 1;
    
      if (/android/i.test(ua)) {
        // 根据高度和 DPR 粗略判断小中大屏安卓设备
        if (logicalHeight <= 640) {
          deviceType = "android_small"; // 如老旧或小尺寸设备
        } else if (logicalHeight > 640 && logicalHeight <= 800) {
          deviceType = "android_medium"; // 常见普通安卓手机
        } else {
          deviceType = "android_large"; // 大屏手机或平板
        }
      } else if (/iPad|iPhone|iPod/.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)) {
        // iPadOS 13+ 会伪装成 Mac，所以需要额外判断触摸能力
        const isIOS = /iP(hone|od|ad)/.test(navigator.userAgent);
        if (!isIOS) return "not-ios";
    
        if (logicalHeight <= 667 && dpr === 2) {
          deviceType = "ios_small";
        } else if (logicalHeight >= 812 && logicalHeight < 926) {
          deviceType = "ios_medium";
        } else if (logicalHeight >= 926) {
          deviceType = "ios_large";
        }
      } else {
        deviceType = "pc";
      }
    
      commit("setDeviceType", deviceType);
    }
  },
  getters: {},
};
